// src/components/device/DeviceLiveData.jsx
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Box, Grid, Card, CardContent, Typography, CircularProgress, Alert } from "@mui/material";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default function DeviceLiveData({ deviceId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  const fetchStatus = useCallback(async () => {
    if (!deviceId) return;
    try {
      setErr("");
      const token = localStorage.getItem("token");
      const res = await axios.get(`${backendUrl}/devices/${deviceId}/status`, {
        headers: { "x-auth-token": token },
      });
      setData(res.data.device);
    } catch (e) {
      console.error("Live status fetch failed", e);
      setErr(e?.response?.data?.message || "Failed to fetch live data");
    }
  }, [deviceId]);

  useEffect(() => {
    fetchStatus();
    const i = setInterval(fetchStatus, 3000);
    return () => clearInterval(i);
  }, [fetchStatus]);

  if (err) return <Alert severity="error">{err}</Alert>;

  if (!data) {
    return (
      <Box sx={{ minHeight: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  const items = [
    { k: "Speed", v: `${data.speed || 0} km/h` },
    { k: "ACC", v: data.accStatus ? "ON" : "OFF" },
    { k: "Vehicle", v: data.vehicleStatus || "-" },
    { k: "Battery", v: data.batteryState || "-" },
    { k: "GSM", v: data.gsmSignalState || "-" },
    { k: "Last Update", v: data.timestamp ? new Date(data.timestamp).toLocaleTimeString() : "-" },
  ];

  return (
    <Grid container spacing={2}>
      {items.map((it) => (
        <Grid key={it.k} item xs={12} sm={6} md={4}>
          <Card sx={{ borderRadius: 3, height: "100%" }}>
            <CardContent>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 800 }}>
                {it.k}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 900 }}>
                {it.v}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
